import React, { useState } from 'react';

import Icon from 'dpl/common/components/Icon';
import SearchMenuDrawer from 'dpl/nav_refresh/components/SearchMenuDrawer';
import {
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';

export default function MobileHomepageSearchBar() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  function openSearchMenuDrawer() {
    setIsDrawerOpen(true);
  }

  function closeMenuDrawer() {
    setIsDrawerOpen(false);
  }

  return (
    <div>
      <button
        type="button"
        className="flex items-center gap-12 font-16 lh-title bg-white ba br3 b--default w-100 pv4 ph3"
        aria-label="Breed search"
        onClick={openSearchMenuDrawer}
      >
        <Icon
          className="primary"
          name="fetch-search"
          height="20px"
          width="20px"
        />
        Start your search
      </button>
      {isDrawerOpen && (
        <SearchMenuDrawer
          onClose={closeMenuDrawer}
          breedSearchAnalytics={{
            origin_view: ANALYTICS_VIEWS.HOME,
            origin_view_feature: ANALYTICS_VIEW_FEATURES.SEARCH_HERO
          }}
          shelterSearchAnalytics={{
            view: ANALYTICS_VIEWS.HOME,
            view_feature: ANALYTICS_VIEW_FEATURES.SEARCH_HERO
          }}
        />
      )}
    </div>
  );
}
